import React from "react";
import BaseModal from "./BaseModal";

const SmallModal = ({ titulo, subtitulo, isVisible, setVisible, children }) => {
  return (
    <BaseModal
      titulo={titulo}
      subtitulo={subtitulo}
      isVisible={isVisible}
      setVisible={setVisible}
      maxWidth="sm"
    >
      {children}
    </BaseModal>
  );
};

export default SmallModal;
